<template>
	<div class="o-dashboard">
		<div class="o-dashboard__breadcrumbs">
			<ul class="c-breadcrumbs">
				<li>
					<a href="/eol">EOL overzicht</a>
				</li>
				<li>
					<span>{{ product }}</span>
				</li>
			</ul>
		</div>
        <c-table
            ref="table"
            :columns="columnsProducts"
            :endpoint="'/api/items/itemseolbyproductid/' + this.$route.params.id"
            :placeholder="'Zoeken op serienummer, ordernummer of eindgebruiker'">
        </c-table>
	</div>
</template>
<script>
import View from '@mixins/View';
import Form from '@mixins/Form';
import CTable from '@components/table/Table';

export default {
	mixins: [ View, Form ],
	components: { CTable },
	data() {
		return {
			product: ''
		}
	},
	methods: {
		load(){
			this.$refs.table.load();
		},
	},
	computed: {
		columnsProducts() {
			let columnsProducts = [
				{ name: 'product.name', label: 'Productnaam' },
				{ name: 'serial', label: 'Serienummer', sortable: true },
				{ name: 'order_number', label: 'Ordernummer', sortable: true },
				{ name: 'date_in_use', component: 'CColumnDatetime', label: 'Aanschafdatum', sortable: true },
				{ name: 'client.contact.first_name,client.contact.last_name', label: 'In gebruik door', sortable: true },
				{ name: 'eol_time', label: 'Aantal maanden tot EOL' },
				{ name: 'product.client.name', label: 'Eindklant' },
				{ name: 'product.client.parent.name', label: 'Reseller' },
				{ name: "id", label: "", component: 'CColumnButton', props: { route: 'itemDetail' }},
			];

			return columnsProducts;
		},
	},
    mounted(){
        this.$xhr.get('/api/items/itemseolbyproductid/' + this.$route.params.id).then(({result}) => {
                this.product = result[0].name;
            })
    }
}
</script>
